<!-- appendToSelect -->
<nz-select [nzShowArrow]="true" appendToSelect class="w-100 custom-select" [ngClass]="{'error-select': isErrorSelect}" [nzMode]="csMode"
           [nzPlaceHolder]="csPlaceHolder | translate" [nzShowSearch]="csShowSearch" [nz-tooltip]="selectedValues?.length ? tooltipMoreSelectedTpl : ''"
           [nzAutoClearSearchValue]="false" [nzServerSearch]="true" [nzDropdownMatchSelectWidth]="csDropdownMatchSelectWidth" [nzMaxTagPlaceholder]="tagPlaceHolder"
           [nzDisabled]="csDisable" [(ngModel)]="controlValue" (nzOnSearch)="onSearch($event)" [nzNotFoundContent]="noData" [nzCustomTemplate]="defaultTemplate"
            [nzAllowClear]="csAllowClear" (nzScrollToBottom)="loadMorePage()" (ngModelChange)="onModelChange($event); inputChange($event)" (nzOpenChange)="openChange($event)"
            [nzMaxTagCount]="csMaxTagCount! || 1" [nzLoading]="isLoading" [vssUiMaxlengthInput]="256" #nzSelectRef [nzDropdownRender]="csDropdownRenderTpl"
            >
            <!-- [nzSuffixIcon]="checknzSuffixIcon ? 'icons:searchQLCT' : null" -->
  <ng-container *ngFor="let item of options" [ngTemplateOutlet]="optionTpl" [ngTemplateOutletContext]="{item: item, level: 0}"></ng-container>
  <ng-template #optionTpl let-item="item" let-isChild="isChild" let-hide="hide" let-level="level">
    <nz-option [nzHide]="hide"
               [nzValue]="item.value" [nzLabel]="(item.label || item.labelHtml) | translate" nzCustomContent [nzDisabled]="checkDisable(item)">
      <div [class.option-child]="isChild"  [ngStyle]="{'padding-left': isChild && level ? (25 * level) - 18 + 'px' : 'auto'}" >
        <div class="d-flex justify-content-between w-100" *ngIf="csIsMultiLevel">
          <a (click)="nextLevel(item)" class="action" *ngIf="item?.children?.length">
            <i class="pe-1" nzType="caret-down" [nzRotate]="item.expanded ? 0 : -90" nz-icon nzTheme="outline" ></i>
          </a>
          <div class="label-option" [class.no-icon-expand]="!item?.children?.length" [innerHtml]="(item.labelHtml | translate) || ((item.label | translate) | vssUiHighlightText : keywordSearch : {class: 'text-high-light'})"></div>
        </div>
        <span *ngIf="!csIsMultiLevel" [innerHtml]="item.labelHtml || (item.label | translate | vssUiHighlightText : keywordSearch : {class: 'text-high-light'})"></span>
      </div>
    </nz-option>
    <ng-container *ngFor="let child of item?.children" [ngTemplateOutlet]="optionTpl" [ngTemplateOutletContext]="{item: child, isChild: true, hide: hide || !item.expanded, level: level + 1}"></ng-container>
<!--    <nz-option-group [nzLabel]="labelOptionGroup" *ngIf="item.expanded">-->
<!--      <ng-template #labelOptionGroup><span class="active" [innerHTML]="item.labelHtml || item.label"></span></ng-template>-->
<!--      <ng-container *ngFor="let child of item?.children" [ngTemplateOutlet]="optionTpl" [ngTemplateOutletContext]="{item: child}"></ng-container>-->
<!--    </nz-option-group>-->
  </ng-template>
  <ng-container *ngFor="let item of selectedValues">
    <nz-option [nzValue]="item.value" [nzLabel]="(item.label | translate) || (item.labelHtml | translate)" nzCustomContent [nzHide]="options | includesObject : item : 'value' : 'children'">
      <span [innerHtml]="(item.labelHtml | translate) || (item.label | translate)"></span>
    </nz-option>
  </ng-container>
  <ng-template #tagPlaceHolder let-selectedList><div title="">+ {{ selectedList.length }}...</div></ng-template>
  <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>
    <i nz-icon nzType="loading" class="loading-icon" aria-hidden="true"></i>
    Loading Data...
  </nz-option>
</nz-select>
<ng-template #defaultTemplate let-selected>
  <div class="cs-select-scroll-item-selected">
    <span class="text-muted" *ngIf="suffixLabelSelected">{{ suffixLabelSelected | translate }}</span>
    {{selected.nzLabel | translate}}
  </div>
</ng-template>
<ng-template #noData>
  <nz-empty nzNotFoundImage="/assets/icons/empty.svg" [nzNotFoundContent]="contentTpl"></nz-empty>
</ng-template>
<ng-template #contentTpl>
  <span>
    {{'BASE.NO_DATA_2' | translate}}
  </span>
</ng-template>
<ng-template #tooltipMoreSelectedTpl>
  <div *ngIf="csMode == 'multiple'">
    <ul class="list-item-tooltip">
      <li  *ngFor="let item of selectedValuesAsync"><span [innerHtml]="(item.labelHtml | translate) || (item.label | translate)"></span></li>
    </ul>
  </div>
  <ng-container *ngIf="csMode != 'multiple'">
    <ng-container *ngFor="let item of selectedValuesAsync">
      <div>
        <span [innerHtml]="(item.labelHtml | translate) || (item.label | translate)"></span>
      </div>
    </ng-container>
  </ng-container>
</ng-template>
